import React, { FC, ReactElement } from 'react';
import localeFieldResolver from '../../../../../helpers/locale-field-finder';
import { internalizationState } from '../../../../../stores/reducers/sections';
import { useSelector } from 'react-redux';

interface Props {
  data: UserDto;
  name: string;
}

export interface UserDto {
  id: number;
  descriptionRu: string;
  descriptionEn?: string;
  fullnameRu: string;
  fullnameEn?: string;
  photo: string;
}

const User: FC<Props> = ({ name, data: {photo, descriptionRu, descriptionEn, fullnameRu, fullnameEn} }): ReactElement => {
  const { activeLangState } = useSelector(internalizationState);
  const localeData = {
    description_ru: descriptionRu,
    description_en: descriptionEn,
    fullname_ru: fullnameRu,
    fullname_en: fullnameEn,
  };
  
  
  return (
    <li>
      <div className="user-list__img">
        <img src={photo} alt="" />
      </div>
      <div className="user-list-info">
        <div className="user-list__position">{name}</div>
        <div className="user-list__name">{localeFieldResolver(localeData, 'fullname_ru', activeLangState)}</div>
      </div>
    </li>
  );
};

export default User;
